import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import './bootstrap.min.css'
import './base-layout.css'
import './fonts.css'
import './ccm.base.css'
import './index.css'

const Layout = ({ children, data }) => (
  <div>
    <Helmet>
      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
      <title>{data.site.siteMetadata.title}</title>
      <meta
        name="description"
        content="DAN EV - Dienst am Nächsten. Nachbarschaftshilfe von Mensch zu Mensch."
      />
      <meta name="generator" content="webdesign.io" />
    </Helmet>
    <div className="main-wrapper">
      {children()}
      <div className="footer">
        <div className="container mb2">
          <Link to="/datenschutz/">Datenschutz</Link> | &nbsp;
          <Link to="/impressum/">Impressum</Link> | &nbsp;
          <Link to="/kontakt/">Kontakt</Link> | &copy;{' '}
          {new Date().getFullYear()} Dienst am N&auml;chsten e.V.
        </div>
      </div>
    </div>
  </div>
)

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js